export default "__VITE_ASSET__DJ$RPttF__"